<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="tableData"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column width="50"
                       type="index"
                       prop="serialNo"
                       :label="this.$t('alarmHistory.index')">
      </el-table-column>
      <!-- 配件类型 -->
      <el-table-column prop="accessoryType"
                       :label="this.$t('serviceSupport.accessoryType')">
      </el-table-column>
      <!-- 配件位置 -->
      <el-table-column prop="accessoryLocation"
                       :label="this.$t('serviceSupport.accessoryPosition')">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import cloneDeep from 'lodash';

export default {
  props: {
    // info
    tableData: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/AccessoryTable.vue